import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1bbc10a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d1bbc10a&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1bbc10a')) {
      api.createRecord('d1bbc10a', component.options)
    } else {
      api.reload('d1bbc10a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d1bbc10a", function () {
      api.rerender('d1bbc10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/smallDrawer/index.vue"
export default component.exports